export function formatNumberWithComma(input: number, maxNumberOfDigits: number, removeTrailingZeros?:boolean): string {
	// Convert number to a string with max decimal places using toFixed.
	let formattedNumber = input.toFixed(maxNumberOfDigits);

	// Remove trailing zeros after the decimal point.
	if(removeTrailingZeros){
		formattedNumber = formattedNumber.replace(/(\.\d*?)0+$/, '$1').replace(/\.$/, '');
	}

	// Replace dot with comma.
	return formattedNumber.replace('.', ',');
}

export function roundToTwoDecimals(input: number): number {
	return Math.round(input * 100) / 100;
}

const EMPTY_FIGURE = "–";

/** One decimal place, German format. `null` shows "–". Above 100 is valid. */
export function formatPercentage(percentage: number | null): string {
	if (percentage === null) return EMPTY_FIGURE;
	return `${formatNumberWithComma(percentage, 1)} %`;
}
